import React, { useEffect, useState } from 'react';
import styles from './VendorInfoList.module.css';
import VerticalFlex from 'routes/vendorRe/containers/commons/VerticalFlex';
import FlexChild from 'routes/vendorRe/containers/commons/FlexChild';
import HorizontalFlex from 'routes/vendorRe/containers/commons/HorizontalFlex';
import P from 'routes/vendorRe/containers/commons/P';
import vendorThumb from 'routes/vendorRe/images/vendor_thumb.png';
import allGreen from 'routes/vendorRe/images/all_green.png';
import allError from 'routes/vendorRe/images/all_error.png';
import {
    infoFontSize1,
    infoEm,
    spaceAround,
    success,
    error,
    systemEnd,
    systemStart,
    adminConnect,
    infoHeight,
    contentCenter,
    commonGap,
} from 'routes/vendorRe/constraint/constraints';
import { useNavigate } from 'react-router-dom';
import Center from 'layouts/wrapper/Center';

const VendorInfoList = (props) => {
    const { data } = props;
    const [store, setStore] = useState();
    const navigate = useNavigate();
    useEffect(() => {
        if (props.data) {
            setStore(data);
        }
    }, [props])
    const onStoreDetailClick = () => {
        if (props.url) {
            navigate(props.url, { state: { data: store } });
        } else {
            navigate(`/vendor/main/detail/${store.id}`, { state: { data: store } })
        }

    }
    return (
        <FlexChild backgroundColor="#fff" borderRadius={infoEm} padding="15px">
            <VerticalFlex gap={15} flexStart>
                <FlexChild>
                    <HorizontalFlex gap={10} alignItems={"flex-start"}>
                        <FlexChild width={"initial"}>
                            <img className={styles.vendorThumb} src={vendorThumb} alt='점포 썸네일' />
                        </FlexChild>
                        <FlexChild>
                            <VerticalFlex justifyContent={spaceAround} gap={10}>
                                <FlexChild justifyContent={contentCenter} alignItems={contentCenter}>
                                    <HorizontalFlex>
                                        <FlexChild>
                                            <P size={"min(3.2vw, 15px)"}>{data && data.storeName}</P>
                                        </FlexChild>
                                        <FlexChild justifyContent={"flex-end"}>
                                            <P cursor color={"#ddd"} onClick={onStoreDetailClick} size={"min(2.2vw, 15px)"}>상세보기 {" >"}</P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild justifyContent={contentCenter} alignItems={contentCenter}>


                                    {
                                        store &&
                                        <VerticalFlex flexStart >
                                            <FlexChild>
                                                <HorizontalFlex gap={15}>
                                                    <FlexChild width={"max-content"}>
                                                        <P size={"min(2vw, 14px)"}>키오스크:</P>
                                                    </FlexChild>
                                                    {store.machines.filter(machine => machine.orderNo === 1 || machine.orderNo === 2).map((kiosk, index) => {
                                                        
                                                        return (
                                                            <FlexChild key={index}>
                                                                <HorizontalFlex gap={10}>
                                                                    <FlexChild width={"initial"}>
                                                                        <img className={styles.status} src={kiosk.heartbeat ? allGreen : allError} alt={kiosk.heartbeat ? success : error} />
                                                                    </FlexChild>
                                                                    <FlexChild>
                                                                        <Center width={"100%"} textAlign={"left"}>
                                                                            <span style={{ fontSize: "min(2vw, 14px)" }}>{kiosk.heartbeat ? success : error}</span>
                                                                        </Center>
                                                                    </FlexChild>
                                                                </HorizontalFlex>
                                                            </FlexChild>
                                                        );
                                                    })}

                                                </HorizontalFlex>
                                            </FlexChild>
                                            {/* <FlexChild>
                                                <HorizontalFlex gap={15}>
                                                    <FlexChild width={"max-content"}>
                                                        <P size={"min(2vw, 14px)"}>머신:</P>
                                                    </FlexChild>
                                                    {store.machines.filter(machine => machine.orderNo >= 3).map((machine, index) => {

                                                        return (
                                                            <FlexChild key={index}>
                                                                <HorizontalFlex gap={10}>
                                                                    <FlexChild width={"initial"}>
                                                                        <img className={styles.status} src={machine.heartbeat ? allGreen : allError} alt={machine.heartbeat ? allGreen : allError} />
                                                                    </FlexChild>
                                                                    <FlexChild>
                                                                        <Center width={"100%"} textAlign={"left"}>
                                                                            <span style={{ fontSize: "min(2vw, 14px)" }}>{machine.heartbeat ? success : error}</span>
                                                                        </Center>
                                                                    </FlexChild>
                                                                </HorizontalFlex>
                                                                <P size={infoFontSize1}>


                                                                </P>
                                                            </FlexChild>
                                                        );
                                                    })}
                                                </HorizontalFlex>

                                            </FlexChild> */}
                                        </VerticalFlex>
                                    }
                                    {/* 
                                                정상인지 오류인지에 따라서 변하는 구간 

                                                1. 정상인 경우
                                                <P size={infoFontSize1}>
                                                    <img className={styles.status} src={allGreen} alt={success} />
                                                    <span style={{marginLeft: infoEm}}>{success}</span>
                                                </P>

                                                2. 에러인 경우
                                                <P size={infoFontSize1}>
                                                    <img className={styles.status} src={allError} alt={error} />
                                                    <span style={{marginLeft: infoEm}}>{error}</span>
                                                </P>
                                            */}
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild>
                {/* <FlexChild>
                    <HorizontalFlex gap={commonGap}>
                        <FlexChild>
                            <div className={styles.sysCloseBtn}>
                                <P size={"min(2vw, 14px)"}>{systemEnd}</P>
                            </div>
                        </FlexChild>
                        <FlexChild>
                            <div className={styles.button}>
                                <P size={"min(2vw, 14px)"}>
                                    {systemStart}
                                </P>
                            </div>
                        </FlexChild>
                        <FlexChild>
                            <div className={styles.button}>
                                <P size={"min(2vw, 14px)"}>
                                    {adminConnect}
                                </P>
                            </div>
                        </FlexChild>
                    </HorizontalFlex>
                </FlexChild> */}
            </VerticalFlex>
        </FlexChild>
    );
};

export default VendorInfoList;